import {
  type ComponentType,
  type DetailedHTMLProps,
  forwardRef,
  type InputHTMLAttributes,
} from 'react';

import clsx from 'clsx';

import { InputFilter } from './InputFilter';

export const WrappedInput = forwardRef<
  HTMLInputElement,
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
    label?: string;
    error?: string | boolean;
    wrappedClassName?: string;
    innerClassName?: string;
    /**@deprecated */
    isOnModal?: boolean;
    symbol?: ComponentType | string;
    symbolRight?: boolean;
    labelSize?: 'sm' | 'xs' | 'md';
    requiredMark?: boolean;
  }
>(function WrappedInput(
  {
    error,
    className,
    wrappedClassName,
    innerClassName,
    symbol: Symbol,
    symbolRight,
    ...props
  },
  ref
) {
  return (
    <div className={clsx(className, 'isolate flex flex-col gap-y-1')}>
      <div
        className={clsx(
          'flex h-full [&>div]:w-full',
          symbolRight && 'flex-row-reverse'
        )}
      >
        {Symbol && (
          <span
            className={clsx(
              `bg-brand pointer-events-none z-10 flex h-[42px] w-10 items-center justify-center
              text-lg font-bold text-gray-800`,
              symbolRight
                ? '-ml-10 rounded-r [&+div>input]:pr-11'
                : '-mr-10 rounded-l [&+div>input]:pl-11 [&+div>label]:!left-11'
            )}
          >
            {typeof Symbol === 'string' ? Symbol : <Symbol />}
          </span>
        )}
        <InputFilter
          {...props}
          ref={ref}
          className={wrappedClassName}
          innerClassName={innerClassName}
          labelClassName={clsx(
            Symbol && symbolRight && '!max-w-[calc(100%-3rem)]'
          )}
          error={error && ' '}
        />
      </div>
      {typeof error === 'string' && (
        <p className="text-xs font-semibold text-red-500 dark:text-red-300">
          {error}
        </p>
      )}
    </div>
  );
});
